const pillars = [
  { icon: 'ri-megaphone-line', label: 'Stigma Reduction' },
  { icon: 'ri-first-aid-kit-line', label: 'Seizure First Response' },
  { icon: 'ri-links-line', label: 'Referral Strengthening' },
  { icon: 'ri-team-line', label: 'Family Support' },
  { icon: 'ri-bar-chart-2-line', label: 'Local Data Generation' },
];

export default function FlagshipProgram() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-4">
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B]">Signature Initiative</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center mb-4 leading-tight">
          Northern Nigeria Epilepsy <br className="hidden md:block" />
          <span className="text-[#7B2D8B]">Access &amp; Dignity Initiative</span>
        </h2>
        <p className="text-gray-500 text-center max-w-2xl mx-auto mb-16 leading-relaxed">
          Our flagship multi-component platform — culturally grounded, evidence-informed, and compatible with every one of IKIRU&apos;s published pillars. Not a single activity, but a living system of change.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative rounded-3xl overflow-hidden h-80 lg:h-full min-h-[360px]">
            <img
              src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Kano%20Nigeria%20cityscape%20at%20golden%20hour%2C%20minarets%20and%20traditional%20architecture%20visible%2C%20warm%20amber%20light%2C%20wide%20panoramic%20shot%2C%20vibrant%20urban%20African%20city%2C%20beautiful%20and%20dignified%20atmosphere&width=800&height=600&seq=flagship01&orientation=landscape"
              alt="Northern Nigeria Epilepsy Access and Dignity Initiative"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2D0A35]/80 via-transparent to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-2 rounded-full bg-[#C084FC] animate-pulse"></div>
                <span className="text-purple-200 text-xs font-semibold uppercase tracking-widest">Anchored in Kano</span>
              </div>
              <p className="text-white text-sm leading-relaxed">
                Amplified nationally through Abuja — building local legitimacy before scaling to higher-level advocacy and systems change.
              </p>
            </div>
          </div>

          <div>
            <div className="bg-[#FAF7FC] rounded-2xl p-8 border border-purple-100 mb-6">
              <h3 className="font-bold text-gray-900 text-lg mb-3">Why This Initiative?</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">
                Evidence from Nigeria shows epilepsy stigma is driven by beliefs linking seizures to curses, witchcraft, and spirit possession — reducing school participation, employment, and treatment-seeking. The treatment gap in Northern Nigeria is severe.
              </p>
              <p className="text-gray-500 text-sm leading-relaxed">
                IKIRU&apos;s response is a Hausa-language, faith-aware, community-rooted platform that converts awareness into practical skills, measurable outcomes, and lasting system change.
              </p>
            </div>

            <div>
              <p className="text-xs font-semibold uppercase tracking-widest text-[#7B2D8B] mb-4">Five Outcomes This Initiative Delivers</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {pillars.map((p) => (
                  <div key={p.label} className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-purple-100">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#7B2D8B]/10 shrink-0">
                      <i className={`${p.icon} text-[#7B2D8B] text-base`}></i>
                    </div>
                    <span className="text-gray-700 text-sm font-medium">{p.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
